import type { ListBuilderList } from '../../../types';

/**
 * Fulfilled list configuration
 * Shows completed/fulfilled sourcing requests
 */
export const fulfilledList: ListBuilderList = {
	id: 'default-sourcing-requests-fulfilled',
	cacheTTL: 300000,
	name: 'Fulfilled',
	type: 'default',
	active: true,
	sortOrder: 10,
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestStatus: {
			defaultValue: [{ id: 'fulfilled', label: 'Fulfilled' }],
			locked: true,
			hidden: true,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
